import React from "react";
import { Link } from "gatsby";
import kubeLogo from "../images/kube/kube-logo.svg";

const Navbar = ({ selection }) => (
  <nav className="navbar productNavbar">
    <div className="container">
      <div className="navbar-brand">
        <Link className="navbar-item" to="/products/kubernetes/">
          <img src={kubeLogo} alt="" style={{ height: "22px" }} />
        </Link>
      </div>

      <div className="navbar-menu">
        <div className="navbar-start">
          <Link to="/products/kubernetes/" className={`navbar-item ${selection === "overview" ? "is-active" : ""}`}>
            Overview
          </Link>
          <Link to="/products/kubernetes/pricing" className={`navbar-item ${selection === "pricing" ? "is-active" : ""}`}>
            Pricing
          </Link>
        </div>
      </div>
    </div>
  </nav>
);

export default Navbar;
